import { Amount } from "@/shared/components";
import { LoanIcon, MoreIcon } from "@/shared/components/SvgIcons";
import { useAppSelector } from "@/shared/hooks";
import { Divider } from "@ab.uitools/ui-library/components/Divider";
import { Text } from "@ab.uitools/ui-library/components/Text";
import type { MouseEvent } from "react";

interface Props {
  index: number;
  balance: number;
  currency: string;
  className?: string;
  interestRate: number;
  contractNumber: string;
  hasMoreAction?: boolean;
  handleShowBalances: (i: number) => void;
}

export const FinanceItem = ({
  balance,
  index,
  currency,
  className,
  interestRate,
  hasMoreAction,
  contractNumber,
  handleShowBalances,
}: Props) => {
  const showBalances = useAppSelector((state) => state.dashboard.showBalances);

  const onShowBalance = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    handleShowBalances(index);
  };

  return (
    <div
      className={`finance-item flexbox align-items--center pl-32 pr-32 widget-content-item ${className}`}>
      <div className="item-icon flexbox align-items--center justify-content--center">
        <div className="flexbox align-items--center justify-content--center">
          <LoanIcon/>
        </div>
      </div>
      <div className="flexbox flex-direction--column pl-16 finance-item-content-wrapper">
        {!!index && (
          <Divider
            color="light"
            type="primary"
            isHorizontal
          />
        )}
        <div className="flexbox full-width pt-18 pb-18 finance-item-body-wrapper">
          <div className="flexbox flex-direction--column finance-item-body">
            <div className="full-width flexbox justify-content--between">
              <Text size="medium" weight="semibold" className="pr-16 truncate contract-number">
                {contractNumber}
              </Text>

              <div
                onClick={onShowBalance}
                className="flexbox justify-content--center align-items--end flex-direction--column pr-6"
              >
                <Amount
                  className="balance"
                  currency={currency}
                  amount={balance}
                  isShow={showBalances[index]}
                />
              </div>
            </div>
            <div className="flexbox align-items--center rate mt-4">
              <Text className="mr-4" type="tertiary">{interestRate}%</Text>
            </div>
          </div>
          {hasMoreAction && (
            <div className="cursor-pointer flexbox align-items--center">
              <MoreIcon type="secondary"/>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
